import React, { useState, useEffect, useContext } from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Collapse from '@material-ui/core/Collapse'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'

import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'

import dayjs from 'dayjs'

import _firebaseContext from '../../contexts/firebaseContext'
import _appContext from '../../contexts/appContext'

const useStyles = makeStyles((theme) => ({
    historyWrapper: {
        maxHeight: 900,
        overflow: 'auto',
    },
    historyList: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    backdrop: {
        zIndex: 9999,
    },
    progress: {
        color: '#fff',
    },
    label: {
        // width: '100%',
    },
    previewWrapper: {
        width: '100%',
    },
    detailsWrapper: {
        paddingLeft: 25,
    },
}))

// const PrettyPrintJson = ({ data }) => {
//     return (
//         <div>
//             <pre>{JSON.stringify(data, null, 2)}</pre>
//         </div>
//     )
// }

const DetailsWrapper = ({ data }) => {
    const classes = useStyles()
    let fields = []
    return (
        <div className={classes.detailsWrapper}>
            <pre>{JSON.stringify(data, null, 2)}</pre>
        </div>
    )
}

function ListItemWrapper({ doc }) {
    const classes = useStyles()
    const [expand, setExpand] = useState(false)

    const handleClick = () => {
        setExpand(!expand)
    }

    return (
        <>
            <ListItem button onClick={handleClick}>
                <div className={classes.previewWrapper}>{doc.id}</div>
                {expand ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={expand} timeout="auto" unmountOnExit>
                <DetailsWrapper data={doc.data} />
                {/* <PrettyPrintJson data={doc.data.object} /> */}
            </Collapse>
            <Divider />
        </>
    )
}

export default function ReceiptsDialog({ open, onClose, user }) {
    const classes = useStyles()
    const [receipts, setReceipts] = useState([])

    const firebaseContext = useContext(_firebaseContext)
    const appContext = useContext(_appContext)

    useEffect(() => {
        const fetchingState = firebaseContext.data.fetchingState['receipts']

        if (fetchingState) {
            appContext.startLoading()
        } else {
            appContext.endLoading()
        }
    })

    const getReceipts = () =>
        firebaseContext.getReceipts(user.id).then((doc) => setReceipts(doc))

    useEffect(() => {
        getReceipts()
    }, [])

    return (
        <>
            <Dialog
                fullWidth
                maxWidth="md"
                open={open}
                onClose={onClose}
                className={classes.historyWrapper}
            >
                <DialogTitle>История подписок</DialogTitle>
                <DialogContent>
                    {receipts === undefined || receipts.length === 0 ? (
                        <Typography>Пока нет истории</Typography>
                    ) : (
                        <List className={classes.historyList}>
                            {receipts.map((doc) => (
                                <ListItemWrapper key={doc.id} doc={doc} />
                            ))}
                        </List>
                    )}
                </DialogContent>
            </Dialog>
        </>
    )
}
